// Shared in-memory flag used to coordinate logout across components.
//
// During logout we clear the Okta tokens, which flips authState to
// unauthenticated and makes SecureRoute try to re-authenticate via
// signInWithRedirect(). Because the master Deere SSO session is still alive,
// that re-login succeeds silently and drops the user back on the app instead
// of logging out. This flag lets SecureRoute skip that redirect while a logout
// is in progress. It lives in memory, so it resets automatically on the
// full-page navigation to the SSO signout URL.
let loggingOut = false;

export const setLoggingOut = (value) => {
    loggingOut = value;
};

export const isLoggingOut = () => loggingOut;
